import latinize from 'latinize'

export const sanitizeString = (value: string) => latinize(value).toLowerCase()
